import './App.css';
import {
    Badge,
    Button,
    Divider,
    Flex,
    Image,
    message,
    Switch,
    Timeline,
    TimelineItemProps,
} from 'antd';
import parse from 'html-react-parser';
import useSWR from 'swr';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import { JSX } from 'react/jsx-runtime';
import { HTMLReactParserOptions, Element } from 'html-react-parser';
import Loading from './Loading';
import { Helmet } from 'react-helmet-async';

const { Title } = Typography;

const options: HTMLReactParserOptions = {
    replace(domNode) {
        if (domNode instanceof Element && domNode.attribs) {
            if (domNode.name === 'img') {
                return <Image style={{maxHeight: '500px'}} src={domNode.attribs.src} />
            }
        }
    },
};

const fetcher = async (url: string) => {
    const res = await fetch(url, {
        headers: new Headers({
            'Access-Control-Allow-Origin': '*',
        }),
    });
    const json = await res.json();
    if (!json.success) {
        const error = new Error((await json).message);
        throw error;
    }
    return json;
};

const Wiki = () => {
    const { data, error, isLoading } = useSWR(
        'https://api.lynne.com.cn/wiki/wiki',
        fetcher
    );

    if (isLoading) return <Loading />;
    if (error) return <div>failed to load</div>;
    let items: TimelineItemProps[] | { children: JSX.Element }[] | undefined =
        [];
    data.data.forEach(
        (element: {
            wiki: any;
            date: string | number | Date | dayjs.Dayjs | null | undefined;
        }) => {
            const date = dayjs(element.date).format('YYYY-MM-DD');
            items?.push({
                children: (
                    <>
                        <Title level={4} style={{ margin: '0' }}>
                            {date}
                        </Title>
                        {element.wiki.map(
                            (
                                content: {
                                    tags: any;
                                    wiki_id: number;
                                    title: string;
                                    content: string;
                                },
                                index: number
                            ) => {
                                return (
                                    <div key={content.wiki_id} className='wiki'>
                                        <Divider />
                                        <Flex align='center' justify='middle'>
                                            <Title
                                                level={5}
                                                style={{ margin: '0' }}>
                                                {content.title}
                                            </Title>
                                            {content.tags.map(
                                                (
                                                    tag: {
                                                        name: string;
                                                        color: string;
                                                    },
                                                    index: any
                                                ) => {
                                                    return (
                                                        <Badge
                                                            key={
                                                                tag.name + index
                                                            }
                                                            color={tag.color}
                                                            count={tag.name}
                                                        />
                                                    );
                                                }
                                            )}
                                        </Flex>
                                        {parse(content.content, options)}
                                    </div>
                                );
                            }
                        )}
                    </>
                ),
            });
        }
    );
    // 渲染数据
    return (
        <>
            <Flex align='center' justify='middle'>
                <Title level={2} style={{ margin: '15px 0' }}>
                    狐狐百科~
                </Title>
                <Badge color='#66CCFF' count='才不是黑历史' />
            </Flex>
            <Helmet>
        <meta
          name="description"
          content="这里才不是黑历史~"
        />     
        <meta name="keywords" content="星海玲奈,VUP,狐狐百科,北极狐,小狐凃,玲奈的dd站,棉花糖投稿" />
      </Helmet>
            <Switch onChange={() => message.info("不许anti！")}></Switch>Anti 模式
            <br />
            <br />
            <Timeline items={items} />
        </>
    );
};

export default Wiki;
